import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  @Input() message: string = '';
  @Input() type: 'success' | 'error' | 'warning' = 'success';
  @Input() showToast: boolean = false;

  constructor(
    private toastService: ToastService,
    private translate: TranslateService
  ) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
  }

  ngOnInit() {
    this.toastService.toast$.subscribe((toast) => {
      this.message = toast.message;
      this.type = toast.type;
      this.showToast = toast.showToast;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showToast'] && this.showToast) {
      setTimeout(() => {
        this.showToast = false;
      }, 5000);
    }
  }

  translateToastType(type: 'success' | 'error' | 'warning') {
    if (type === 'success') {
      return this.translate.instant('toast.success');
    } else if (type === 'warning') {
      return this.translate.instant('toast.warning');
    } else if (type === 'error') {
      return this.translate.instant('toast.error');
    }
  }
}
